import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ImageModule } from '@df/module-image/image.module';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { defaultImagePng } from 'projects/app-default/src/app/icms.config';
interface IPopularCategory {
    image: string;
    title: string;
    url?: string;
    subtitle?: string;
    ctaCopy?: string;
    ctaUrl?: string;
}
interface IPageComponenPopularCategoriesData extends NICmsContentComponent.IData {
    categories: IPopularCategory[];
}
@Component({
    selector: 'page-component-category-carousel',
    templateUrl: './popular-categories.html',
    standalone: true,
    imports: [GridModule, HrefComponent, ImageModule, ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<PageComponentPopularCategoriesComponent>({
    id: 'popular-categories',
    name: 'Popular Categories',
    tags: ['category', 'search'],
    fields: [
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'categories',
            title: 'Categories',
            itemName: 'Category',
            itemNameField: 'title',
            fields: [
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.image,
                    key: 'image',
                    title: 'Image',
                    required: true
                },
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'url',
                    title: 'Link'
                },
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'title',
                    title: 'Title',
                    default: 'Title',
                    required: true
                },
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'subtitle',
                    title: 'Subtitle',
                    default: 'Title'
                },
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'ctaCopy',
                    title: 'Button Text'
                },
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'ctaUrl',
                    title: 'Button Link'
                }
            ],
            default: [
                {
                    title: 'First category',
                    subtitle: 'Subtitle',
                    image: defaultImagePng,
                    ctaCopy: 'View all'
                },
                {
                    title: 'Second category',
                    subtitle: 'Subtitle',
                    image: defaultImagePng
                },
                {
                    title: 'Third category',
                    subtitle: 'Subtitle',
                    image: defaultImagePng
                },
                {
                    title: 'Fourth category',
                    subtitle: 'Subtitle',
                    image: defaultImagePng
                }
            ]
        }
    ]
})
export class PageComponentPopularCategoriesComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: IPageComponenPopularCategoriesData;
}
